export default [
  {
    path: '/dashboard',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: {
      pageTitle: 'Home',
      requiresAuth: true,
      breadcrumb: [
        {
          text: 'Home',
          active: true,
        },
      ],
    },
  },
];
